module.exports = __webpack_public_path__ + "static/media/ZRX-logo.8cf0b2ad.png";